import type {FormKitNode} from '@formkit/core';

const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
const phoneRegex = /^[0-9]{9}$/;

export function isEmailValid(email: string) {
	return emailRegex.test(email);
}

export function isPhoneValid(phone: string) {
	return phoneRegex.test(phone);
}
export function emailCustomRule(node: FormKitNode<string>) {
	return isEmailValid(node.value);
}

export function emailCustomRuleOptional(node: FormKitNode<string>) {
	// Pokud je input prázdný, neprovádíme validaci (vrátíme true)
	if (!node.value || node.value.trim() === '') {
		return true;
	}
	// Pokud něco je vyplněno, validujeme email
	return isEmailValid(node.value);
}

export function phoneCustomRule(node: FormKitNode<string>) {
	return isPhoneValid(node.value);
}
